// extracted by mini-css-extract-plugin
export default {"header-box":"BridgeErrorRecord_header-box__Ofy3S","value-box":"BridgeErrorRecord_value-box__9WDrN","word-break":"BridgeErrorRecord_word-break__gmM5k"};